import apiClient from '@/services/axios'
import { getErrorMessage } from '@/views/apps/fortune-wheel/composables/useGetErrorMessage.js'

const referralApiUrl = process.env.VUE_APP_REFERRAl_API_URL

const getOptions = async (context, loadingName, optionUrl, defaultMaxOptions = 50, roleId, name = '') => {
  try {
    context[`${loadingName}`] = true

    const url = `${referralApiUrl}/${optionUrl}`

    const requestParams = { per_page: defaultMaxOptions }
    if (roleId) {
      requestParams.role = roleId
    }
    if (name) {
      requestParams.name = name
    }

    const response = await apiClient.get(url, { params: requestParams })

    if (response?.data?.data) {
      const { data, meta } = response.data
      return { data, meta }
    }

    getErrorMessage(response?.data)
    return null
  } finally {
    context[`${loadingName}`] = false
  }
}

export { getOptions }
